<template>
  <v-container fluid>
  <!-- Heading -->
    <slot name="breadcrumbs" />
    <v-divider />
    <slot name="heading" />
    <v-divider />
    <v-row>
      <v-col sm="12" md="12" class="py-0 my-0">
        <slot name="tabs" />
      </v-col>
      <v-col sm="12" md="12" class="ma-0 pa-0">
        <slot name="content" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ProjectDetailLayout",
  data() {
    return {
      id: this.$route.params.id
    }
  }
}
</script>
